import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Caption from '../../Theme/Fonts/Caption'
import { TextColorTypes } from '../../Theme/Fonts/FontTypes'
import { TestID } from '../../utils/PropTypesDefinitions'

type PublishedInfoProps = TestID & {
    published?: string
    color?: TextColorTypes
}

const PublishedInfo: FunctionComponent<PublishedInfoProps> = ({
    published,
    color = 'keshi-3',
    testID,
}): ReactElement => {
    return (
        <Grid noExpand flexShrink={0} testID={testID}>
            {published ? (
                <Caption numberOfLines={1} color={color}>
                    {published}
                </Caption>
            ) : null}
        </Grid>
    )
}

export default PublishedInfo
